import { DURATION, EASE, useReducedMotion } from '@/lib/motion-presets';
import { CheckIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'motion/react';

type AuthSuccessOverlayProps = {
	show?: boolean;
};

export default function AuthSuccessOverlay({ show }: AuthSuccessOverlayProps) {
	const reducedMotion = useReducedMotion();

	if (reducedMotion && show) {
		return null;
	}

	return (
		<AnimatePresence>
			{show ? (
				<motion.div
					className='pointer-events-none fixed inset-0 z-50 flex items-center justify-center bg-background/40 backdrop-blur-[2px]'
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					exit={{ opacity: 0 }}
					transition={{ duration: DURATION, ease: EASE }}
				>
					<motion.div
						className='flex h-20 w-20 items-center justify-center rounded-full border border-[var(--auth-red)]/40 bg-[var(--auth-red-muted)] shadow-lg'
						initial={{ scale: 0.6, opacity: 0 }}
						animate={{ scale: 1, opacity: 1 }}
						exit={{ scale: 1.1, opacity: 0 }}
						transition={{ type: 'spring', stiffness: 400, damping: 24 }}
					>
						<CheckIcon className='text-[var(--auth-red)]' size={36} strokeWidth={2.5} />
					</motion.div>
				</motion.div>
			) : null}
		</AnimatePresence>
	);
}
